export function parseRequestRate(raw,minimum,maximum) {
  const text=String(raw??'').trim();
  if(text==='')return null;
  if(!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text))throw new Error('محدودیت درخواست باید عدد مثبت باشد؛ برای مقدار نامشخص خالی بگذارید.');
  const value=Number(text);
  if(!Number.isFinite(value)||value<minimum||value>maximum)throw new Error(`محدودیت درخواست باید بین ${minimum} و ${maximum} باشد.`);
  return value;
}
export function requestRatePayload(rps,rpm) {
  return {translation_requests_per_second:parseRequestRate(rps,0.01,10000),translation_requests_per_minute:parseRequestRate(rpm,1,600000)};
}
export function previewRequestInterval(rps,rpm,fallback=2.2) {
  const rates=requestRatePayload(rps,rpm);
  const intervals=[];
  if(rates.translation_requests_per_second!==null)intervals.push(1/rates.translation_requests_per_second);
  if(rates.translation_requests_per_minute!==null)intervals.push(60/rates.translation_requests_per_minute);
  return intervals.length?Math.max(...intervals)+0.2:fallback;
}
